import React from 'react';
import _ from 'lodash';
import { Box, Typography } from "@mui/material";
import useAppInfo from '../../../../hooks/appInfo.hook';
import { useUser } from "../../../../contexts/user.context";
import Warnings from "../../../../components/publish/Warnings";
import MissingDataCard from "../../../../components/publish/MissingDataCard";
import PublishedCard from "../../../../components/publish/PublishedCard";
import PublishButton from "../../../../components/publish/PublishButton";
import AppStatus from '../../Main/AppStatus';
import AndroidIcon from '@mui/icons-material/Android';

export default function UpdatePublish(props) {
  const { appInfo, isAppBeingPublished } = useAppInfo();
  const { user } = useUser();

  const publishStatus = appInfo.androidPublishStatus;
  const downloadUrl = appInfo.androidDownloadUrl;

  function isMissingData() {
    return (
      _.isEmpty(user?.store?.title) ||
      _.isEmpty(user?.store?.shortDescription) ||
      _.isEmpty(user?.store?.description) ||
      _.isEmpty(user?.store?.privacyPolicyUrl) ||
      _.isEmpty(user?.store?.keywords) ||
      _.isEmpty(user?.store?.launchScreenUrl) ||
      _.isEmpty(user?.store?.iconUrl) ||
      _.isEmpty(user?.store?.featureGraphicUrl)
    )
  }

  return (
    <Box sx={{ paddingX: 2, paddingY: 4 }}>
      <Box display="flex" flexWrap="wrap" marginTop={2} sx={{ justifyContent: { sm: 'start', xs: 'center' } }}>
          <AndroidIcon sx={{ color: "#2cc69d", marginRight: 1 }} />
          <Typography align="left" variant="subtitle1">
              Status do aplicativo Android
          </Typography>
      </Box>

      <AppStatus
          downloadUrl={appInfo.androidDownloadUrl}
          isAppBeingPublished={isAppBeingPublished('android')}
          platformName="Android"
          publishStatus={appInfo.androidPublishStatus}
          storeName="Play Store"
          lastPublishRequestedAt={appInfo.androidLastPublishRequestedAt}
          deadlineInDays={20}
      />
      
      <Box mt={8}>
        {!isAppBeingPublished('android') && isMissingData() &&
          <MissingDataCard />
        }

        {(publishStatus == 'first_publish_pending' || publishStatus == 'pending_update') && !isMissingData() &&
          <>
            <Warnings deadlineInDays={20} downloadUrl={downloadUrl} platformName="Android" publishStatus={publishStatus} />
            <PublishButton platform="android" />
          </>
        }

        {publishStatus == 'published' && !isMissingData() &&
          <PublishedCard platform="Android" />
        }
      </Box>
    </Box>
  )
}